import Card from "@components/ui/Card";
import { Button, Typography } from "@hellocarbo/lasagne";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router";

function TrajectoryBuildActionPlan() {
  const { t } = useTranslation(["common", "trajectory"]);

  return (
    <Card>
      <Typography as="h1" step="2" weight="bold" className="mb-xs">
        {t("trajectory:buildActionPlan.title")}
      </Typography>
      <Typography>
        <Trans
          i18nKey="trajectory:buildActionPlan.text"
          components={{ 1: <br /> }}
        />
      </Typography>
      <div className="mt-xl gap-x-md flex justify-center">
        <Button as={Link} to="/trajectory/creation/summary" shape="outline">
          {t("common:back")}
        </Button>
        <Button as={Link} to="/trajectory/action-plan">
          {t("trajectory:buildActionPlan.cta")}
        </Button>
      </div>
    </Card>
  );
}

export default TrajectoryBuildActionPlan;
